import React from "react";
import "../../Styles/certified/draftronix.css";

export default function Finzly() {
  return (
    <>
      <div className="draftronix-certified-details-section">
        <div className="draftronix-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="draftronix-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="draftronix-certified-details-left">
            <img
              src="/assets/draftronix//draft_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="draftronix-certified-badge"
            />
            <div className="draftronix-certified-company-names">
              <a href="https://draftronix.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/draftronix/draft.png"
                alt="Walkzero Logo"
                className="draftronix-certified-company-logo"
              />
            </a>
              <h1 className="draftronix-certified-full-name">
              Draftronix Engineering Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="draftronix-certified-details-right">
            <img
              src="/assets/draftronix/draft_3.jpeg"
              alt="Finzly Office"
              className="draftronix-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="draftronix-certified-description">
          <h2>
            Why  Draftronix Engineering Private Limited is an Outstanding Workplaces
          </h2>
          <p>
          Draftronix is a global BIM, CAD, and engineering services company supporting the AEC industry with precision-driven and scalable solutions. Our team works closely with architects, engineers, and contractors to streamline project delivery, improve coordination, and reduce rework.


          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="draftronix-certified-info-cards">
          <div className="draftronix-certified-info-card">
            <div className="draftronix-certified-info-title">COMPANY SIZE</div>
            <div className="draftronix-certified-info-value">55 Employees</div>
          </div>
          <div className="draftronix-certified-info-card">
            <div className="draftronix-certified-info-title">INDUSTRY</div>
            <div className="draftronix-certified-info-value">  Civil Engineering Services

</div>
          </div>
          <div className="draftronix-certified-info-card">
            <div className="draftronix-certified-info-title">CONNECT</div>
            <div className="draftronix-certified-info-icons">
              <span className="draftronix-certified-icon-round">
                <a href="https://draftronix.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="draftronix-certified-icon-round">
                <a href="https://www.linkedin.com/company/draftronix/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              
            </div>
          </div>
          <div className="draftronix-certified-info-card">
            <div className="draftronix-certified-info-title">LOCATION (HQ)</div>
            <div className="draftronix-certified-info-value">Hyderabad, Telangana</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="draftronix-certified-recognition-section">
          <h2 className="draftronix-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="draftronix-certified-recognition-badge">
            <img
              src="/assets/draftronix//draft_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="draftronix-certified-recognition-image"
            />
          </div>
          <div className="draftronix-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="draftronix-certified-life-section">
          <h2 className="draftronix-certified-life-title">
            Life at Draftronix Engineering Private Limited
          </h2>
          <div className="draftronix-certified-life-gallery">
            <div className="draftronix-certified-life-col">
              <img src="/assets/draftronix/draft_4.jpeg" alt="Office 1" className="draftronix-certified-life-img" />
              <img src="/assets/draftronix/draft_2.jpeg" alt="Team 1" className="draftronix-certified-life-img" />
            </div>
            <div className="icom-certified-life-col draftronix-certified-life-center">
              <img src="/assets/draftronix/draft_6.jpeg" alt="Main Office" className="draftronix-certified-life-img draftronix-certified-life-img-large" />
            </div>
            <div className="draftronix-certified-life-col">
              <img src="/assets/draftronix/draft_5.jpeg" alt="Office 2" className="draftronix-certified-life-img" />
              <img src="/assets/draftronix/draft_1.jpeg" alt="Team 2" className="draftronix-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
